import { Injectable } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';

import { AppComponent } from '../../app.component';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

@Injectable()
export class ForgotPasswordService {

  constructor(private http:Http) { }

  send(email:string){
     var data:string = `email=${email}`;

     let headers = new Headers();
     headers.append('Content-Type', 'application/x-www-form-urlencoded');

     return this.http.post(AppComponent.DOMAIN + '/api/user/ForgotPassword', data, {
        headers: headers
     }).map( response => response.json() );
  }
}


// WEBPACK FOOTER //
// ./src/app/login/forgot-password/forgot-password.service.ts